import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import AllBlogs from '../../components/AllBlogs';
import NewColumnWithForm from '../../components/NewColumnWithForm';
import NewFeaturedBlogs from '../../components/NewFeaturedBlogs';

export default function InsightsPage({
    global,
    all_news,
    all_featured_news
}) {
    return (
        <>
            <SeoHead
                page_name={`Insights | The global house of tech and transformation recruitment | Lorien`}
                canonical_link={`insights`}
            />
            <MainBanner
                global={global}
                pathPrefix={`insights_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Insights</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-insights.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <NewFeaturedBlogs
                global={global}
                pathPrefix={`insights_page.new_featured_blogs`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Featured Blogs</h2>
                    </>
                }
                post={all_featured_news}

                socialPagePrefix={`insights`}

            />
            <AllBlogs
                global={global}
                pathPrefix={`news_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_news}
                ParentNews={true}

                heading={`All Blogs`}
            />
            <NewColumnWithForm
                global={global}
                pathPrefix={`insights_page.new_column_with_form`}
                customClass={`pb-5`}
                heading={`How can we help you?`}
                formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const featured_news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United Kingdom" || post.country?.en == "All"
            );
        })
        .filter(function (post) {
            return (
                post.featured?.en == true
            );
        });

    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United Kingdom" || post.country?.en == "All"
            );
        });

    const all_news = news.orderBy((news) => Date.parse(news.date?.en), 'desc').getItems();
    const all_featured_news = featured_news.orderBy((news) => Date.parse(news.date?.en), 'desc').getItems();

    return {
        props: {
            global,
            all_news,
            all_featured_news
        }
    };
}
